import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/highlightBNPLBasket/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showHighlightBNPLBasketSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showHighlightBNPLBasketSelector };
